module.exports = __webpack_public_path__ + "static/img/email-pc.681c16d4.png";